export default __webpack_public_path__ + "static/media/t1.69cc4496.png";